// extracted by mini-css-extract-plugin
export var container = "CartTotal_container__VXFWO";
export var item = "CartTotal_item__qK6Na";
export var shared = "\"../../../shared/shared.module.css\"";
export var shipping = "CartTotal_shipping__1JN8K";
export var shopCampaign = "CartTotal_shopCampaign__D2p07";
export var sm = "576px";
export var tooltip = "CartTotal_tooltip__o6GL6";
export var total = "CartTotal_total__HsqiM";